import config from '../config/default/config.json';
export default config;